'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const NewSlimCompassLinear = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M9.811 5.527a.7.7 0 0 0-.16 0l-2.903.752a.64.64 0 0 0-.47.469l-.732 2.928a.642.642 0 0 0 .643.797.7.7 0 0 0 .16 0l2.936-.752a.64.64 0 0 0 .468-.469l.733-2.928a.642.642 0 0 0-.643-.797zM9.105 6.87l-.45 1.81-1.811.45.45-1.81z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M9.362 1.5H6.638A5.14 5.14 0 0 0 1.5 6.638v2.724C1.5 12.2 3.8 14.5 6.638 14.5h2.724c2.838 0 5.138-2.3 5.138-5.138V6.638c0-2.837-2.3-5.138-5.138-5.138M6.638 13.537a4.18 4.18 0 0 1-4.175-4.175V6.638a4.18 4.18 0 0 1 4.175-4.175h2.724a4.18 4.18 0 0 1 4.175 4.175v2.724a4.18 4.18 0 0 1-4.175 4.175z",
                clipRule: "evenodd"
            })
        ]
    })));

export { NewSlimCompassLinear, NewSlimCompassLinear as default };
//# sourceMappingURL=NewSlimCompassLinear.js.map
